<template>
	<!-- 商户进件 -->
	<div class="merchantList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="searchForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="searchForm.ch_merchant_name" placeholder="请输入商户名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.mobile" placeholder="请输入商户手机号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.channel_mer_no" placeholder="请输入商户编号"></el-input>
				</el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="searchForm.id_card" placeholder="请输入商户身份证号"></el-input>
                </el-form-item>
				<el-form-item>
                	<el-select size v-model="searchForm.merchant_type" clearable placeholder="请选择商户类型">
                		<!-- <el-option label="全部" value=""></el-option> -->
                		<el-option label="企业/个体户" :value="2"></el-option>
                		<el-option label="小微商户" :value="3"></el-option>
                	</el-select>
                </el-form-item>

				<el-form-item v-if="level ==0 || level == 1">
					<el-input size clearable v-model="searchForm.real_name" placeholder="请输入归属代理姓名"></el-input>
				</el-form-item>
				<el-form-item v-if="level ==0 || level == 1">
					<el-input size clearable v-model="searchForm.phone" placeholder="请输入归属代理账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="searchForm.check_status" clearable placeholder="请选择审核状态">
						<el-option label="审核中" value="1"></el-option>
						<el-option label="审核通过" value="2"></el-option>
						<el-option label="审核拒绝" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select size="medium" v-model="searchForm.channel_from" filterable clearable style="width:100%"
						placeholder="请选择进件渠道">
						<el-option label="银盛" value="1"></el-option>
						<el-option label="手机" value="2"></el-option>
						<el-option label="杉德" value="3"></el-option>
						<el-option label="联动" value="4"></el-option>
                        <el-option label="海科" value="5"></el-option>
                        <el-option label="银盛尊享" value="6"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
                    <el-select size v-model="searchForm.ys_check_status" clearable placeholder="请选择银盛报备状态">
                        <el-option label="初始化" :value="0"></el-option>
                        <el-option label="报备成功" :value="1"></el-option>
                        <el-option label="商户认证资料审核中" :value="2"></el-option>
                        <el-option label="商户认证资料审核拒绝" :value="3"></el-option>
                        <el-option label="待报备" :value="4"></el-option>
                        <el-option label="已提交报备" :value="5"></el-option>
                        <el-option label="拒绝商户报备重提" :value="6"></el-option>
                        <el-option label="报备失败" :value="9"></el-option>
                        <el-option label="总部报备中" :value="100"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                	<el-select size v-model="searchForm.union_status" clearable placeholder="请选择海科商户报备状态">
                		<!-- <el-option label="全部" value=""></el-option> -->
                		<el-option label="报备成功" value="10A"></el-option>
                		<el-option label="报备失败" value="10B"></el-option>
                        <el-option label="未报备" value="10C"></el-option>
                        <el-option label="需选择结算卡" value="10D"></el-option>
                	</el-select>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="searchForm.link_status" clearable placeholder="请选择联动商户报备状态">
                        <!-- <el-option label="全部" value=""></el-option> -->
                        <el-option label="联动进件上送成功" value="1"></el-option>
                        <el-option label="联动进件成功" value="2"></el-option>
                        <el-option label="银联进件成功" value="3"></el-option>
                        <el-option label="联动绑定设备上送成功" value="4"></el-option>
                        <el-option label="联动绑定设备成功" value="5"></el-option>
                        <el-option label="银联绑定设备成功 " value="-1"></el-option>
                        <el-option label="联动进件上送失败" value="-2"></el-option>
                        <el-option label="联动进件失败" value="-3"></el-option>
                        <el-option label="联动绑定设备上送失败" value="-4"></el-option>
                        <el-option label="银联进件失败" value="-4"></el-option>
                        <el-option label="联动绑定设备失败" value="-5"></el-option>
                        <el-option label="银联绑定设备失败" value="-6"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item>
					<el-date-picker v-model="rangeDate" type="datetimerange" range-separator="至"
						start-placeholder="申请开始日期" end-placeholder="申请结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(searchForm)">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="marchantList" size="mini" border style="width: 100%" v-loading="loading">
				<!-- 序号 -->
				<el-table-column header-align="center" align="center" fixed type="index" label="ID"
					min-width="80"></el-table-column>
				<!-- 商户类型 -->
				<el-table-column header-align="center" align="center" prop="merchant_type" label="商户类型" min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.merchant_type == 1">个体工商户</span>
						<span v-else-if="scope.row.merchant_type == 2">企业商户</span>
						<span v-else>小微商户</span>
					</template>
				</el-table-column>
				<!-- 商户名称 -->
				<el-table-column header-align="center" align="center" prop="ch_merchant_name" label="商户名称"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="channel_mer_no" label="商户编号"
					min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" prop="id_card" label="商户身份证号"
                    	min-width="150"></el-table-column>
				<!-- 商户手机号 -->
				<el-table-column header-align="center" align="center" prop="mobile" label="商户手机号" min-width="120">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" :content="scope.row.mer_phone | desMobile" placement="top">
							<p>{{ scope.row.mer_phone | desMobile }}</p>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="channel_from_text" label="进件渠道"
					min-width="120"></el-table-column>
				<!-- 商户状态 -->
				<el-table-column header-align="center" align="center" prop="check_status" label="商户状态" min-width="120">
				</el-table-column>
                <!-- 商户报备状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="union_status_text"
                    label="商户报备状态"
                    min-width="140"
                ></el-table-column>
                <!-- 商户报备备注 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="check_msg"
                    label="商户报备备注"
                    min-width="140"
                ></el-table-column>
                <!-- 商户报备时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="check_time"
                    label="商户报备时间"
                    min-width="160"
                ></el-table-column>
				<!-- 归属代理姓名 -->
				<el-table-column header-align="center" align="center" prop="real_name" label="归属代理姓名" min-width="120"
					v-if="level ==0 || level == 1"></el-table-column>
				<!-- 归属代理账号 -->
				<el-table-column header-align="center" align="center" prop="phone" label="归属代理账号" min-width="120"
					v-if="level ==0 || level == 1">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
							<p>{{ scope.row.phone | desMobile }}</p>
						</el-tooltip>
					</template>
				</el-table-column>
				<!-- 归属代理编号 -->
				<el-table-column header-align="center" align="center" prop="agent_no" label="归属代理编号" min-width="150"
					v-if="level ==0 || level == 1">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" :content="scope.row.agent_no" placement="top">
							<p>{{ scope.row.agent_no }}</p>
						</el-tooltip>
					</template>
				</el-table-column>
                <!-- 微信编号 -->
                	<el-table-column
                	    header-align="center"
                	    align="center"
                	    prop="wx_merc_no"
                	    label="微信编号"
                	    min-width="150"
                	></el-table-column>
                	<!-- 支付宝编号 -->
                	<el-table-column
                	    header-align="center"
                	    align="center"
                	    prop="ali_merc_no"
                	    label="支付宝编号"
                	    min-width="150"
                	></el-table-column>
				<!-- 申请时间 -->
				<el-table-column header-align="center" align="center" prop="create_time" label="申请时间"
					min-width="150"></el-table-column>
				<!-- 审核时间 -->
				<el-table-column header-align="center" align="center" prop="check_time" label="审核时间"
					min-width="150"></el-table-column>
				<!-- 操作 -->
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="150">
					<template slot-scope="scope">
						<el-button @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>
		<merchant-net-tools v-if="toolsIsShow" :toolsIsShow="toolsIsShow" :isAdd="isAdd" @toolsClose="toolsClose"
			:dialogData="dialogData"></merchant-net-tools>
	</div>
</template>

<script>
	import merchantNetTools from './merchantNetTools';
	export default {
		name: "merchant-net",
		data() {
			return {
				isAdd: false, //
				toolsIsShow: false, //修改代理商
				searchForm: {
					real_name: '',
                    id_card:'',
					check_status: '',
					channel_from: '',
					channel_mer_no:'',
					mobile: '',
					bank_phone: '',
					ch_merchant_name: '',
					real_name: '',
					phone: '',
					start_time: '',
					end_time: '',
					phone: '',
					page: 1,
					limit:10,
				},
				rangeDate: '',
				id: '',
				marchantList: [],
				currentPage: 1, //当前页码
				pageSize: 10, //条数
				total: 0, //总数
				loading: true,
				level: sessionStorage.getItem('level'),
				dialogData: {
					data: {} //当前行的数据
				},
			}
		},
		created() {

		},
		mounted() {
			this.getData({
				page: 1,
				limit: 10
			})
		},
		components: {
			merchantNetTools,
		},
		methods: {
			onSearch(searchFrom) {
				this.currentPage = 1;
				searchFrom.page = 1;
				this.getData(searchFrom);
			},
			getData(params) { //获取数据
				this.loading = true;
				this.$api.post("merchant_channel/selMerchantChannel", params, res => {
					let data = res.data;
					this.total = data.count; //总数
					this.marchantList = res.data.list;
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			handleCurrentChange(page) { //当前选中页
				this.currentPage = page;
				this.searchForm.page = page;
				this.searchForm.limit = this.pageSize;
				this.getData(this.searchForm);
			},
			handleSizeChange(limit) { //条数
				this.currentPage = 1;
				this.pageSize = limit;
				this.searchForm.page = 1;
				this.searchForm.limit = limit;
				this.getData(this.searchForm);
			},
			handleInfo(row) { //详情
				this.$router.push({
					path: '/merchantNetManyInfo',
					query: {
						id: row.id,
						merchant_type: row.merchant_type
					}
				});
			},
			
			pickerChange(DateArr) { //时间选择器
				this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			changeInfo(row) {
				this.isAdd = true
				this.dialogData.data = row;
				this.toolsIsShow = true;
			},
			toolsClose(ref) { //关闭导入、删除库存
				this.isAdd = false;
				this.toolsIsShow = false;
				if (ref) { //重载表格
					this.getData({
						page: this.page.currentPage,
						limit: this.page.pageSize
					})
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	.merchantList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>